module.exports = __webpack_public_path__ + "img/ICONO1.83881ad6.png";